
  import { mapState, mapGetters } from 'vuex'
  import bannerRedirect from '~/mixins/common/banner-redirect'
  import errorCodeStrings from '~/mixins/common/error-code-strings'
  import baseLogic from '~/mixins/base-logic'
  import ServerSide from '~/mixins/serverSide'
  import Meta from '~/mixins/meta'
  import InitPixel from '~/mixins/initPixel'

  export default {
    name: 'Theme2Layout',
    mixins: [baseLogic, ServerSide, bannerRedirect, Meta, errorCodeStrings, InitPixel],
    data() {
      return {
        isMobileScreen: false
      }
    },
    computed: {
      ...mapGetters({
        languages: 'themes/settings/language',
        banks: 'banks/banks'
      }),
      ...mapState({
        menubars: state => state.cms.menus.menus,
        cms: state => state.cms.cms,
        isLogin: state => state.settings.isLogin,
        player: state => state.player.player,
        showHoldBalance: state => state.sockets.showHoldBalance,
        displayGetBonusDetail: state => state.sockets.displayGetBonusDetail,
        displayGetBonusModalState: state => state.sockets.displayGetBonusModal,
        floatingIcons: state => state.cms.floatingIcons,
        errorStrings: state => state.themes['language-string'].errorStrings
      }),
      displayGetBonusModal: {
        get() {
          return this.displayGetBonusModalState
        },
        set(value) {
          this.$store.commit('sockets/setDisplayGetBonusModal', value)
        }
      },
      navbarComponentName() {
        return this.isMobileScreen ? 'Theme2MobileNavBar' : 'Theme2DesktopNavBar'
      },
      footerComponentName() {
        return this.isMobileScreen ? 'Theme2MobileFooterComponent' : 'Theme2DesktopFooter'
      }
    },
    watch: {
      $route(to, from) {
        if (!this.$cookie.get('visit') && !this.isInternational)
          this.$store.dispatch('themes/settings/fetchVisitWebsite')
      }
    },
    created() {
      this.$vuetify.theme.dark = true
    },
    async mounted() {
      // To prevent multiple iframes on the website, Issue: https://techcsl.atlassian.net/browse/CSCSL-891
      if (window.top !== window.self) {
        window.top.location.href = '/'
      }

      this.$store?.dispatch('app/checkIsApp')
      // Fetch error code
      await this.getErrorCodeStrings()
      try {
        this.$cookie.set('previous_url', document.referrer)
      } catch (error) {}

      this.showBanner()
      this.$store.dispatch('player/getPlayerInviteAndEarnDomain') // Get invite and earn domain link (refer-friend page)
      this.getFaviconIcon()

      // To set mission basic setting
      // Since the /activities page onMounted also fire this API
      // By handling in the layout layer is to prevent duplicate API fires
      if (this.$route.path !== '/activities')
        this.$store.dispatch('activities/mission-reward/getMissionSettings', {
          currency: this.$store.state.settings.defaultCurrency
        })
      // To fetch VIP Privilege info
      this.$store.dispatch('activities/vip-system/getVipTiers', {
        currency: this.$store.state.settings.defaultCurrency
      })
      this.$store.dispatch('activities/vip-system/getVipSettings', {
        currency: this.$store.state.settings.defaultCurrency
      })
      if (this.$cookie.get('token')) {
        // Get all missions badges (Badges number)
        this.$store.dispatch('activities/mission-reward/getMissionBadge')
        // Get all notifications
        this.$store.dispatch('activities/notification/getNotifications')
        // Get message notification badges
        this.$store.dispatch('themes/player/getMessageNotificationBadges')
      }

      // Fetch the game icon wheel for mobile screen
      if (this.isMobileOnly()) {
        this.$store.dispatch('cms/cmsComponentCode', {
          platform: 2,
          component_code: 'MobileGameWheelIcon'
        })
      }

      if (this.isMobileOnly()) {
        this.$store.dispatch('cms/cmsComponentCode', {
          component_code: 'LiveChat',
          platform: 1
        })
      } else {
        this.$store.dispatch('cms/cmsComponentCode', {
          component_code: 'LiveChat',
          platform: 2
        })
      }

      // Call this store action only when the user is not on the home page and mobile device
      if (this.$route.path !== '/' && !this.isMobileOnly())
        this.$store.dispatch('cms/cmsComponentCode', {
          platform: 1,
          component_code: 'DesktopBackground'
        })
      // Call this store action only when the user is not on the home page but on mobile device
      if (this.$route.path !== '/' && this.isMobileOnly())
        this.$store.dispatch('cms/cmsComponentCode', {
          platform: 2,
          component_code: 'MobileBackground'
        })

      // Check previous language setting
      if (this.$cookie?.get('is_change_language')) {
        this.$store.commit('settings/changeLanguageLoading', true)
      }

      // Local settings
      const locale = this.handleCookie('wl_locale')
      if (locale) {
        this.$recaptcha.language = locale
      }

      // Fetch visit API
      this.$store.dispatch('themes/settings/fetchVisitWebsite')
      this.$store.dispatch('themes/settings/markAssociatedPlayer')
      // Check session
      if (!this.isInternational && !window.sessionStorage.getItem('visit')) {
        this.$store.dispatch('themes/settings/fetchVisitWebsite')
        window.sessionStorage.setItem('visit', 'true')
      }

      this.onResize()
      this.loadData()
      await this.initializeSettings()
      if (this.$route.query?.pixel) {
        // alert(`Pixel ID: ${this.$route.query?.pixel}`)
      }

      // Check playerMessage
      this.$store.subscribeAction((mutation, state) => {
        if (mutation.type === 'sockets/playerMessage') {
          this.$store.dispatch('themes/player/getMessageNotificationBadges')
          if (this.$route.path === '/player/messages') {
            this.$store.dispatch('themes/player/getMessage')
          }
        }
      })
    },
    methods: {
      onResize() {
        const MOBILE_SCREEN_WIDTH = 1300
        this.isMobileScreen = window.innerWidth < MOBILE_SCREEN_WIDTH
        this.$store.commit('themes/settings/setIsMobile', this.isMobileScreen)
      },
      closeHoldBalanceDialog() {
        this.$store.commit('sockets/setShowHoldBalance', false)
      },
      loadData() {
        if (this.menubars.length <= 0) {
          this.$store.dispatch('cms/menus/getMenubars')
        }
        // if (this.cms.length <= 0) {
        //     this.$store.dispatch('cms/cms', {})
        // }
      },

      async initializeSettings() {
        await this.$store.dispatch('settings/supportCountryAndLanguage')
        this.$store.dispatch('cms/floatingIcons')
        if (this.$cookie.get('token')) {
          this.initSocketTheme()
          await this.$store.dispatch('themes/player-bank/getBankPlayerAccount')
          await this.$store.dispatch('banks/accounts')
        }
        if (!this.languages.length) {
          await this.setDefaultLanguages()
        }
        if (this.isInternational && this.$cookie.get('currency')) {
          await this.$store.dispatch('settings/operationSetting', this.$cookie.get('currency'))
        }
        await this.$store.dispatch('themes/settings/getExchangeRate')
        this.$store.commit('settings/changeLanguageLoading', false)
        this.$cookie.remove('is_change_language')
      }
    }
  }
